import {createAction, props} from '@ngrx/store';
import {ITemplate} from '../_interface/full-template';
import {Update} from '@ngrx/entity';

export const loadTemplates = createAction(
	'[Journal 📦 Templates] Loaded 👍',
	props<{ templates: ITemplate[] }>()
);

export const toggleTemplate = createAction(
	'[Journal 📦 Templates] Toggle active',
	props<Update<ITemplate>>()
);

export const deleteTemplate = createAction(
	'[Journal 📦 Templates] Delete one',
	props<{template: ITemplate}>()
);

export const updateTemplate = createAction(
	'[Journal 📦 Templates] Update one',
	props<Update<ITemplate>>()
);

export const updateFailed = createAction(
	'[Journal 📦 Templates] Update error',
	props<Update<ITemplate>>()
);

export const upsertTemplate = createAction(
	'[Journal 📦 Templates] Upsert one',
	props<{template: ITemplate}>()
);

export const upsertTemplateLocally = createAction(
	'[Journal 📦 Templates] Upsert one',
	props<{template: ITemplate}>()
);

export const filterTemplatesByActiveInactive = createAction('[Journal 📦 Templates] Filter templates by active/inactive');

export const filterTemplatesByUsage = createAction('[Journal 📦 Templates] Filter templates by usage');
